import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import * as ProductService from 'services/api/product';
import { LanguagesEnum } from 'constants/languages';
import { ISetting } from 'services/api/settings';

export interface IState {
  taskDetail: {
    status: StateStatus | null;
    data: ISetting[] | null;
  };
  commentTask: {
    status: StateStatus | null;
  };
  commentsList: {
    status: StateStatus | null;
    data: any;
  };
  likeTask: {
    status: StateStatus | null;
  };
  uploadFileComment: {
    data: any;
    status: StateStatus | null;
  };
}

const initialState: IState = {
  taskDetail: {
    status: null,
    data: null,
  },
  commentTask: {
    status: null,
  },
  commentsList: {
    status: null,
    data: null,
  },
  likeTask: {
    status: null,
  },
  uploadFileComment: {
    data: null,
    status: null,
  },
};

const ViewTaskReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_TASK_DETAIL:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME ? state.taskDetail.data : action.data,
        },
      };

    case Types.COMMENT_TASK:
      return {
        ...state,
        commentTask: {
          ...state.commentTask,
          status: action.status || null,
        },
      };
    case Types.SET_COMMENT_TASK:
      return {
        ...state,
        commentsList: {
          ...state.commentsList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.commentsList.data
              : action.data,
        },
      };
    case Types.LIKE_TASK:
      return {
        ...state,
        likeTask: {
          ...state.likeTask,
          status: action.status || null,
        },
      };
    case Types.UPLOAD_FILE_COMMENT:
      return {
        ...state,
        uploadFileComment: {
          ...state.uploadFileComment,
          status: action.status || null,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ViewTaskReducer;
